import { GuestReadinessStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { SortDirection } from '@avantstay/data-grid'

export enum DateKind {
  regular = 'regular',
  weekend = 'weekend',
}

export enum BookingsColorMode {
  ReservationStatus = 'RESERVATION_STATUS',
  PaymentStatus = 'PAYMENT_STATUS',
}

export interface RowProps {
  rowStart: number
  rowSpan: number
}

export interface DayIndexes {
  startDayIndex: number
  endDayIndex: number
}

export interface AvailableDatesRange {
  checkIn: string
  checkOut: string
  ignoreBlocks?: boolean
}

export enum TapeType {
  Booking = 'booking',
  BlockedPeriod = 'blockedPeriod',
}

export enum BlockedPeriodType {
  EditableBlock = 'editableBlock',
  ReadOnlyBlock = 'readOnlyBlock',
}

export enum EconRowType {
  Normal = 'normal',
  HighRisk = 'highrisk',
  OffBoarded = 'offboarded',
}

export interface CreateTapeContextProps {
  hotelRoomTypeId?: string
  home?: {
    id: string
    name: string
    regionName?: string
    unitNumber?: string
    status?: GuestReadinessStatus
    hotelRoomTypeId?: string
  }
  period?: {
    fromDate?: string
    toDate?: string
  }
}

export interface SortOrderProps {
  sortByKey?: string
  sortOrder?: SortDirection
}
